import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from './constants.service';
import { AppConfigService } from 'app/app-config.service';
import { ResponseMyCertificate } from 'app/pages/my-responsibility/my-responsibility.service';

export enum CertificateCategory {
    Certification = 1,
    Practice = 2,
    Reference = 3
}
export class CertificateModel {
    certificateId: number;
    certificateCode: string;
    certificateName: string;
    certificateDetail: string;
    effectiveStartDate: Date;
    effectiveEndDate: Date;
    certificateTypeId: number;
    createDate: Date;
    createBy: number;
    updateDate: Date;
    updateBy: number;
    active: boolean;
    isDeleted: boolean;
}
export class ResponseCertificate {
    certificateId: number;
    certificateCode: string;
    certificateName: string;
    certificateDetail: string;
    effectiveStartDate: string;
    effectiveEndDate: string;
    certificateTypeId: number;
    certificateTypeName: string;
    extendTypeName: string;
    roundExtendPlanName: string;
    advanceDate: number;
    prepareDate: number;
}
export class SearchRelevantCertificateByLaw {
    lawId: number;
}

export interface ResponseLawRelevantCertificate {
    lawId: number;
    certificates: Array<CertificateModel>;
}
@Injectable()
export class CertificateService {

    constructor(
        private http: HttpClient,
        private configService: AppConfigService,
        private constantsService: ConstantsService) {


    }



    getCertificateByCode(code: string): Observable<any> {
        return this.http.get(`${this.configService.getConfiguration().apiUrl}/Certificate/GetCertificateByCode/${code}`);
    }

    getCertificateDetailById(id: number): Observable<ResponseCertificate> {
        return this.http.get<ResponseCertificate>(`${this.configService.getConfiguration().apiUrl}/Certificate/GetCertificateById/${id}`);
    }

    getRelevantCertificateByLawId(id: number): Observable<ResponseLawRelevantCertificate> {
        return this.http.get<ResponseLawRelevantCertificate>(`${this.configService.getConfiguration().apiUrl}/RelevantLaw/GetRelevantCertificateByLawId/${id}`);
    }

    getCertificateByUserId(id: number): Observable<ResponseMyCertificate> {
        return this.http.get<ResponseMyCertificate>(`${this.configService.getConfiguration().apiUrl}/MyCertificate/GetCertificateByUserId/${id}`);
    }

    getCertificateCategory(): Observable<any> {
        return this.constantsService.getConstants('CertificateCategory');
    }

}
